var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"subject-dropdown",attrs:{"options":_vm.options,"value":_vm.value,"multiple":_vm.multiple,"name":_vm.name,"placeholder":_vm.placeholder},on:{"input":_vm.input}})
}
var staticRenderFns = []

export { render, staticRenderFns }